/* OSZEA — section rendering */
function ph(label, cls){ return `<div class="ph ${cls||''}"><span class="ph-label">[ ${label} ]</span></div>`; }
function wx(key, cls, vb){ return svg(key, cls, vb||48); }

/* 5 — FORECAST CONSOLE */
function renderForecast(){
  return `
  <section class="forecast section section-pad" id="forecast" data-screen-label="Forecast console">
    <div class="wrap">
      <div class="fc-head reveal">
        <div class="section-head">
          <div class="eyebrow">Forget the Forecast</div>
          <h2>Your city's weather changes. Your plans don't have to.</h2>
        </div>
      </div>
      <div class="console reveal d1">
        <div class="console-bar">
          <span class="console-status"><span class="live"></span>Live weather module · placeholder data</span>
          <div class="console-tabs" id="fcTabs">
            <button class="console-tab active" data-region="nz">New Zealand</button>
            <button class="console-tab" data-region="au">Australia</button>
          </div>
          <span class="console-clock" id="fcClock">--:--</span>
        </div>
        <div class="console-ticker"><div class="ticker-track" id="fcTicker"></div></div>
        <div class="console-body">
          <div class="sky" id="fcSky" data-cond="showers">
            <div class="sky-fx"><span class="sky-cloud c1"></span><span class="sky-cloud c2"></span><span class="sun"></span><div class="weatherlines"></div></div>
            <div class="sky-top">
              <div><div class="sky-city" id="skyCity">Auckland</div><div class="sky-region" id="skyRegion"><span class="rb">NZ</span> New Zealand</div></div>
              <span id="skyIco"></span>
            </div>
            <div class="sky-mid">
              <div class="sky-temp" id="skyTemp">18<sup>°C</sup></div>
              <div class="sky-meta"><div class="cond" id="skyCond">Showers</div><div class="sky-stats" id="skyStats"></div></div>
            </div>
            <div class="sky-rec">
              <div class="rec-thumb"><div class="ph" id="skyThumb"><span class="ph-label">Tasman</span></div></div>
              <div class="rec-info">
                <div class="rec-lab"><span class="rec-pick-badge">Today's OSZEA Pick</span></div>
                <div class="rec-prod" id="skyProd">Tasman Essentials</div>
              </div>
              <button class="btn btn-primary btn-sm js-add" data-add="Tasman Essentials" data-price="${window.OSZEA_DYNAMIC_PRICING?.['Tasman Essentials'] || 113}" id="skyCta">Shop Tasman <span class="arw">→</span></button>
            </div>
          </div>
          <div class="city-grid" id="fcGrid"></div>
        </div>
        <div class="console-foot">
          <span class="fc-micro">Forecast says rain. Your socks say no worries.</span>
          <a href="#featured" class="btn btn-primary">Shop For Today's Weather <span class="arw">→</span></a>
        </div>
      </div>
    </div>
  </section>`;
}

/* 6 — PERSONAS · "Whatever your day looks like" (continuous + interactive) */
function renderPersonas(){
  const spotlight = PERSONAS.map((p,i)=>`
    <div class="ps-slide ${i===0?'active':''}" data-ps="${i}">
      ${ph(p.ph)}
      <span class="ps-slide-grad"></span>
      <span class="ps-slide-body">
        <span class="ps-tag">${svg(p.icon,'ps-tag-ico',24)} ${p.tag}</span>
        <span class="ps-slide-title">${p.label}</span>
        <span class="ps-slide-line">${p.line}</span>
        <span class="ps-slide-foot">
          <span class="ps-prod">${p.prod} · ${window.money(p.price)}</span>
          <span class="btn btn-primary btn-sm js-add" data-add="${p.prod}" data-price="${p.price}">${p.cta} <span class="arw">→</span></span>
        </span>
      </span>
    </div>`).join('');
  const chip = (p,i)=>`<button class="ps-chip ${i===0?'active':''}" data-ps="${i}" type="button">${svg(p.icon,'ps-chip-ico',24)}<span>${p.label}</span></button>`;
  const chips = PERSONAS.map(chip).join('');
  return `
  <section class="personas section section-pad" id="personas" data-screen-label="Whatever your day looks like">
    <div class="wrap">
      <div class="section-head reveal" style="max-width:680px">
        <div class="eyebrow">Built for real lives</div>
        <h2>Whatever Your Day Looks Like</h2>
        <p class="lead">Pick your day. We'll show the fit.</p>
      </div>
      <div class="ps-stage reveal d1">
        <div class="ps-spotlight" id="psSpotlight">
          ${spotlight}
          <span class="ps-progress"><i id="psProgress"></i></span>
        </div>
        <div class="ps-side">
          <div class="ps-side-lab">Pick the one that's <b>you</b> — the photos keep rolling</div>
          <div class="ps-list" id="psList">${chips}</div>
          <div class="ps-side-foot">
            <span class="ps-count"><span class="ps-dot"></span><span id="psIndex">01</span> / ${String(PERSONAS.length).padStart(2,'0')}</span>
            <span class="ps-hint">Tap any to lock your fit →</span>
          </div>
        </div>
      </div>
    </div>
  </section>`;
}

/* 7 — FEATURED PRODUCTS */
function renderProducts(){
  const cards = PRODUCTS.map(p=>`
    <article class="pcard reveal">
      <div class="pcard-media">
        <span class="tag-pill ${p.tagCls} pcard-tag">${p.tag}</span>
        <button class="pcard-quick" aria-label="Quick view">${svg('search','',24)}</button>
        ${ph(p.ph)}
        <div class="pcard-chips">${p.chips.map(c=>`<span class="pchip">${c}</span>`).join('')}</div>
      </div>
      <div class="pcard-body">
        <div class="pcard-row"><h3 class="pcard-name">${p.name}</h3><span class="pcard-price">${window.money(p.price)}</span></div>
        <p class="pcard-desc">${p.line}</p>
        <div class="pcard-swatch">${p.swatches.map(s=>`<span class="sw" style="background:${s}"></span>`).join('')}</div>
        <div class="pcard-foot"><button class="btn btn-dark btn-block js-add" data-add="${p.name}" data-price="${p.price}">${p.cta} <span class="arw">→</span></button></div>
      </div>
    </article>`).join('');
  return `
  <section class="featured section section-pad" id="featured" data-screen-label="Featured products">
    <div class="wrap">
      <div class="section-head reveal">
        <div class="eyebrow">The range</div>
        <h2>Weather-Ready Essentials</h2>
        <p class="lead">Waterproof comfort for grown-ups, kids, and everything in between.</p>
      </div>
      <div class="prod-grid">${cards}</div>
    </div>
  </section>`;
}

/* 8 — ZEA-TEX TECH (homepage preview — bright, product-led, correct 4 layers) */
function renderTech(){
  const hotspots = TECH_FEATS.map((f,i)=>`<button class="tech-hotspot th${i+1}" data-layer="${i}" type="button" aria-label="${f.name}"><span class="th-dot"></span><span class="th-num">${i+1}</span></button>`).join('');
  const layers = TECH_FEATS.map((f,i)=>`
    <button class="tech-layer ${i===0?'hot':''}" data-layer="${i}" type="button">
      <span class="tl-num">${i+1}</span>
      <span class="tl-text"><span class="tl-name">${f.name}</span><span class="tl-desc">${f.desc}</span></span>
    </button>`).join('');
  return `
  <section class="tech section section-pad" id="tech" data-screen-label="ZEA-TEX technology preview">
    <div class="wrap">
      <div class="section-head reveal" style="max-width:600px">
        <div class="eyebrow">The Technology</div>
        <h2>Why Your Feet Stay Dry</h2>
        <p class="lead">Four flexible layers help block water, support comfort, and keep every step light.</p>
      </div>
      <div class="tech-grid reveal d1">
        <div class="tech-diagram">
          ${ph('ZEA-TEX\u2122 4-Layer Shoe Visual \u2014 Product Cutaway or Exploded Layers')}
          ${hotspots}
        </div>
        <div class="tech-side">
          <div class="tech-layers" id="techLayers">${layers}</div>
          <div class="tech-cta">
            <a href="ZEA-TEX Technology.html" class="btn btn-primary">Explore ZEA-TEX\u2122 <span class="arw">\u2192</span></a>
            <a href="#featured" class="btn btn-ghost">Shop Waterproof Shoes <span class="arw">\u2192</span></a>
          </div>
        </div>
      </div>
    </div>
  </section>`;
}

/* 9 — WHY OSZEA (full-bleed image, content overlaid) */
function renderWhy(){
  const items = WHY.map(w=>`
    <div class="why-item">
      <span class="why-ico">${svg(w.icon,'',24)}</span>
      <span class="wt-name">${w.name}</span>
    </div>`).join('');
  return `
  <section class="why section section-pad" data-screen-label="Why OSZEA">
    <div class="wrap">
      <div class="why-stage reveal" id="whyStage">
        <div class="why-bg"><img src="/assets/why-oszea.jpg" class="ph" style="width:100%; height:100%; object-fit:cover;" alt="Why OSZEA"></div>
        <span class="why-scrim"></span>
        <div class="why-overlay">
          <div class="eyebrow on-dark">Built for real weather</div>
          <h2 class="why-title">Why OSZEA</h2>
          <div class="why-list">${items}</div>
          <a href="#featured" class="btn btn-light why-cta">Shop All Styles <span class="arw">→</span></a>
        </div>
      </div>
    </div>
  </section>`;
}

/* 10 — DOWN UNDER STORIES */
function renderStories(){
  const cards = STORIES.map(s=>`
    <a class="story-card reveal" href="#featured">
      ${ph(s.ph)}
      <div class="story-body">
        <div class="story-loc">${svg('pin','sl-ico',24)}<b>${s.city}</b></div>
        <div class="story-line">${s.line}</div>
        <div class="story-rec"><span class="sr-prod">${s.prod}</span><span class="sr-cta">Shop the Fit <span class="arw">→</span></span></div>
      </div>
    </a>`).join('');
  return `
  <section class="section section-pad" data-screen-label="Down Under stories">
    <div class="wrap">
      <div class="section-head reveal">
        <div class="eyebrow">Down Under</div>
        <h2>Made for Weather That Can't Make Up Its Mind</h2>
        <p class="lead">From Auckland drizzle to Melbourne mood swings, OSZEA is built for places where the weather changes before your plans do.</p>
      </div>
      <div class="stories-grid">${cards}</div>
    </div>
  </section>`;
}

/* 11 — ONE SHOE EVERY MOOD */
function renderEveryMood(){
  const cards = EVERYMOOD.map(e=>`
    <a class="em-card reveal" href="#featured">
      ${ph(e.ph)}
      <div class="em-body">
        <span class="em-pill">${e.title} <span class="arw">→</span></span>
        <div class="em-cap">${e.cap}</div>
      </div>
    </a>`).join('');
  return `
  <section class="everymood section section-pad" data-screen-label="One shoe every mood">
    <div class="wrap">
      <div class="section-head reveal">
        <div class="eyebrow">One pair, sorted</div>
        <h2>One Shoe. Every Mood.</h2>
        <p class="lead">Workdays, wet weekends, school runs, beach walks — OSZEA fits right in.</p>
      </div>
      <div class="em-grid">${cards}</div>
      <div class="reveal d2" style="text-align:center;margin-top:40px"><a href="#featured" class="btn btn-dark">Find Your Everyday Pair <span class="arw">→</span></a></div>
    </div>
  </section>`;
}

/* 12 — UGC */
function renderUGC(){
  const cards = UGC.map(u=>`
    <div class="ugc-card reveal">
      ${ph(u.ph)}
      <button class="ugc-mute" aria-label="Unmute">${svg('mute','',24)}</button>
      <button class="ugc-play" aria-label="Play">${svgFill('play','',24)}</button>
      <div class="ugc-label"><div class="ul-tag">${u.tag}</div><div class="ul-name">${u.name}</div></div>
    </div>`).join('');
  return `
  <section class="section section-pad" style="background:var(--paper)" data-screen-label="UGC video proof">
    <div class="wrap">
      <div class="section-head reveal" style="margin-inline:auto;text-align:center">
        <div class="eyebrow" style="justify-content:center">Community tested</div>
        <h2>Community-Tested Waterproof Comfort</h2>
        <p class="lead">Real customers. Real wet weather. Real dry socks.</p>
      </div>
      <div class="ugc-grid">${cards}</div>
      <div class="reveal d2" style="text-align:center;margin-top:36px">
        <p style="font-family:var(--font-mono);font-size:12.5px;color:var(--grey-600);letter-spacing:.04em;margin-bottom:18px">Follow @oszeaofficial for more real-weather tests.</p>
        <a href="#" class="btn btn-dark">Watch Customer Stories <span class="arw">→</span></a>
      </div>
    </div>
  </section>`;
}

/* 13 — REVIEWS */
function renderReviews(){
  const cards = REVIEWS.map(r=>`
    <article class="rev-card reveal">
      <div class="rev-stars">★★★★★</div>
      <p class="rev-text">"${r.text}"</p>
      <div class="rev-by">
        <div class="rev-av">${r.init}</div>
        <div><div class="rev-name">${r.name}</div><div class="rev-badge">Customer review</div></div>
      </div>
    </article>`).join('');
  return `
  <section class="section section-pad" style="background:#fff" data-screen-label="Reviews">
    <div class="wrap">
      <div class="section-head reveal" style="margin-inline:auto;text-align:center">
        <div class="eyebrow" style="justify-content:center">Trusted &amp; loved</div>
        <h2>Trusted and Loved</h2>
        <p class="lead">Stories from people wearing OSZEA across New Zealand and Australia.</p>
      </div>
      <div class="rev-grid">${cards}</div>
      <div class="rev-trust reveal d2"><b>Waterproof comfort</b> for everyday weather <span class="sep"></span> NZ &amp; AU shipping</div>
    </div>
  </section>`;
}

/* 14 — ELEMENTS */
function renderElements(){
  const cards = ELEMENTS.map(e=>`
    <article class="el-card reveal">
      <div class="el-media">${e.bg ? `<img src="${e.bg}" class="ph" style="width:100%;height:100%;object-fit:cover" alt="${e.name}">` : ph(e.ph)}<div class="el-ico">${svg(e.icon,'',24)}</div></div>
      <div class="el-body">
        <div class="el-top">
          <div class="el-name">${e.name}</div>
          <p class="el-line">${e.line}</p>
        </div>
        <div class="el-foot">
          <span class="el-price">${window.money(e.price)}</span>
          <button class="btn btn-dark btn-sm js-add" data-add="${e.name}" data-price="${e.price}">Add <span class="arw">→</span></button>
        </div>
      </div>
    </article>`).join('');
  return `
  <section class="elements section section-pad" id="elements" data-screen-label="OSZEA Elements">
    <div class="wrap">
      <div class="section-head reveal">
        <div class="eyebrow">For Sun · For Wind · For Water</div>
        <h2>OSZEA Elements</h2>
      </div>
      <div class="el-grid">${cards}</div>
    </div>
  </section>`;
}

/* 15 — SOCKS */
function renderSocks(){
  return `
  <section class="socks section section-pad" id="socks" data-screen-label="Socks upsell">
    <div class="wrap">
      <div class="socks-card reveal">
        <div class="socks-media">${ph('Product Photo — OSZEA Socks')}</div>
        <div class="socks-body">
          <div class="micro">Complete the fit</div>
          <h2>Complete the Fit</h2>
          <p>Soft, breathable comfort socks made for daily wear.</p>
          <div class="socks-opts" id="sockOpts">
            <button class="sock-opt active" data-qty="1" data-price="12"><div class="so-name">1 Pair</div><div class="so-price">$12</div></button>
            <button class="sock-opt" data-qty="3" data-price="30"><div class="so-name">3 Pack</div><div class="so-price">$30</div><div class="so-save">Save $6</div></button>
          </div>
          <div class="socks-add">
            <button class="btn btn-primary js-add" id="sockAdd" data-add="OSZEA Socks (1 Pair)" data-price="12">Add Socks <span class="arw">→</span></button>
            <span class="socks-total" id="sockTotal">$12 · breathable cotton blend</span>
          </div>
        </div>
      </div>
    </div>
  </section>`;
}

/* 16 — RAINCLUB SIGNUP (interactive) */
function renderRainClub(){
  const interests = ['Rainy commutes','Dog walks','Kids','Hiking','Everyday'];
  const perks = [
    { icon:'drop', t:'Early Access' },
    { icon:'shield', t:'10% First Order' },
    { icon:'cloud', t:'Weather-Ready Tips' },
    { icon:'refresh', t:'Member Restocks' },
  ];
  return `
  <section class="rainclub section section-pad" data-screen-label="RainClub signup">
    <span class="rc-glow rc-glow-a"></span><span class="rc-glow rc-glow-b"></span>
    <div class="weatherlines rc-rain"></div>
    <div class="wrap">
      <div class="rc-shell reveal">
        <div class="rc-left">
          <div class="eyebrow">RainClub · Free to join</div>
          <h2>Join the RainClub</h2>
          <p>Early drops, member pricing, and weather-ready tips for real NZ &amp; AU days.</p>
          <form class="rc-form js-rcjoin" novalidate>
            <div class="rc-field">
              <input type="email" placeholder="Enter your email" aria-label="Email" required>
              <button class="btn btn-dark" type="submit">Join Now <span class="arw">→</span></button>
            </div>
            <div class="rc-meta"><span class="rc-live-dot"></span>Made for changing weather across NZ &amp; AU</div>
            <button type="button" class="rc-nurse" id="rcNurseBtn">
            <span class="rc-nurse-ico">${svg('shield','',24)}</span>
            <span class="rc-nurse-txt"><b>Nurses &amp; healthcare workers</b> — verify to unlock an extra <b>20% off</b>, every order. <span class="rc-nurse-note">NZ &amp; AU only</span></span>
            <span class="rc-nurse-cta">Verify <span class="arw">→</span></span>
          </button>
          </form>
          <div class="rc-success" id="rcSuccess" aria-hidden="true">
            <span class="rc-check">${svg('check','',24)}</span>
            <div><div class="rc-success-t">You're in the RainClub ☔</div><div class="rc-success-d" id="rcSuccessD">Check your inbox for 10% off your first order.</div></div>
          </div>
        </div>
        <div class="rc-right">
          <div class="rc-perks-lab">Your membership, sorted</div>
          <div class="rc-perks">
            ${perks.map((p,i)=>`
              <div class="rc-perk" style="--d:${i*0.06}s">
                <span class="rc-perk-ico">${svg(p.icon,'',24)}</span>
                <div class="rc-perk-t">${p.t}</div>
              </div>`).join('')}
          </div>
        </div>
      </div>
    </div>
  </section>`;
}

/* 17 — RAINCLUB MAP */
function renderMap(){
  const pins = MAP_PINS.map((p,i)=>`
    <button class="pin ${p.rain?'rain':''}" data-pin="${i}" style="left:${p.x}%;top:${p.y}%" aria-label="${p.city}">
      <span class="ring"></span><span class="dot"></span><span class="pin-label">${p.city}</span>
    </button>`).join('');
  const rail = MAP_PINS.map((p,i)=>`
    <button class="rail-card" data-pin="${i}">
      <div class="rc-thumb">${ph('RainClub Story — '+p.city)}</div>
      <div><div class="rc-city">${svg(p.key,'wx',48)} ${p.city}</div><div class="rc-quote">"${p.quote}"</div></div>
    </button>`).join('');
  return `
  <section class="rcmap section section-pad" id="rainclub" data-screen-label="RainClub map">
    <div class="wrap">
      <div class="rcmap-head reveal">
        <div class="eyebrow on-dark">RainClub · NZ &amp; AU</div>
        <h2>Show Us Where Your OSZEAs Take You</h2>
        <p>From Auckland drizzle to Melbourne mood swings — see how the RainClub moves through every kind of weather.</p>
      </div>
      <div class="map-stage reveal d1">
        <div class="map-canvas" id="mapCanvas">
          <span class="ph-label" style="position:absolute;top:14px;left:16px;z-index:3;font-family:var(--font-mono);font-size:10px;letter-spacing:.1em;color:rgba(255,255,255,.32)">[ RainClub Map — Australia &amp; New Zealand ]</span>
          <svg class="map-svg" viewBox="0 0 100 70" preserveAspectRatio="xMidYMid meet">
            <path class="map-mass" d="M18 30 Q16 22 24 20 Q30 17 38 19 Q44 16 50 20 Q55 24 54 30 Q56 38 50 44 Q48 52 42 56 Q38 62 32 58 Q24 60 20 52 Q14 46 16 38 Q15 33 18 30 Z" fill="rgba(95,200,194,.07)" stroke="rgba(95,200,194,.22)" stroke-width="0.4"/>
            <path class="map-mass" d="M80 30 Q82 26 84 30 Q88 36 86 42 Q84 46 81 44 Q78 40 79 35 Q78 31 80 30 Z" fill="rgba(95,200,194,.07)" stroke="rgba(95,200,194,.22)" stroke-width="0.4"/>
            <path class="map-mass" d="M74 50 Q73 47 76 48 Q80 52 78 58 Q76 63 73 61 Q71 57 72 53 Q72 51 74 50 Z" fill="rgba(95,200,194,.07)" stroke="rgba(95,200,194,.22)" stroke-width="0.4"/>
            <path class="map-route lit" d="M46 40 Q64 30 81 38"/>
            <path class="map-route lit" d="M48 48 Q62 56 75 55"/>
          </svg>
          ${pins}
          <div class="map-tip" id="mapTip"></div>
        </div>
        <div class="map-rail">
          <div class="map-rail-head">Latest from the RainClub</div>
          <div class="rail-scroll" id="mapRail">${rail}</div>
        </div>
      </div>
      <div class="rcmap-foot reveal d2">
        <a href="#" class="btn btn-primary">Join RainClub <span class="arw">→</span></a>
        <a href="#" class="btn btn-ghost on-dark">Follow @oszeaofficial</a>
      </div>
    </div>
  </section>`;
}

/* 15 — WANDER WIDE / GUARANTEE (full-bleed image + floating trust panel) */
function renderShip(){
  const cards = SHIP.map((s,i)=>`
    <li class="promise-item">
      <span class="pi-num">${String(i+1).padStart(2,'0')}</span>
      <span class="pi-ico">${svg(s.icon,'',24)}</span>
      <div class="pi-name">${s.name}</div>
      <div class="pi-desc">${s.desc}</div>
    </li>`).join('');
  return `
  <section class="promise section" data-screen-label="Wander wide guarantee">
    <div class="wrap">
      <div class="promise-inner reveal">
        <div class="promise-grid">
          <div class="promise-head">
            <div class="eyebrow">The promise</div>
            <h2 class="promise-title">Wander Wide.<br>Leave Worries Aside.</h2>
            <div class="promise-actions">
              <a href="#featured" class="btn btn-dark promise-cta">Shop Waterproof Shoes <span class="arw">→</span></a>
              <a href="#tech" class="promise-link">Learn More <span class="arw">→</span></a>
            </div>
          </div>
          <div class="promise-media">${ph('Lifestyle Photo — Shoes Being Put On Near Door')}</div>
        </div>
        <ul class="promise-list">${cards}</ul>
      </div>
    </div>
  </section>`;
}

/* 19 — FOOTER */
function renderFooter(){
  const cols = [
    ['Shop',['Men','Women','Kids','Elements','Add-ons','Tasman Essentials','Urban Essentials']],
    ['Help',['Contact Us','Shipping','Returns &amp; Exchanges','Size Guide','Shoe Care','FAQ']],
    ['About OSZEA',['Our Story','ZEA-TEX™ Technology','Materials','RainClub','Reviews','Sustainability']],
  ].map(([h,items])=>`<div class="foot-col"><h4>${h}</h4><ul>${items.map(i=>`<li><a href="#">${i}</a></li>`).join('')}</ul></div>`).join('');
  const ticker = ['Auckland drizzle','Wellington wind','Melbourne mood swings','Sydney showers','Queenstown cold snaps','Brisbane humidity','Christchurch chill','Adelaide breeze'];
  const tk = ticker.map(t=>`<span class="foot-ticker-item">${t}<span class="tdot"></span></span>`).join('');
  return `
  <footer class="footer" data-screen-label="Footer">
    <canvas class="foot-water" id="footWater" aria-hidden="true"></canvas>
    <div class="foot-ticker"><div class="foot-ticker-track">${tk}${tk}</div></div>
    <div class="wrap">
      <div class="foot-top">
        <div class="foot-brand">
          <div class="fb-statement">Forget the <span class="teal">Forecast.</span></div>
          <p class="fb-sub">Waterproof comfort made for real NZ &amp; AU weather.</p>
          <div class="foot-news">
            <div class="fn-lab">Stay Dry With Us</div>
            <form method="post" action="/contact#contact_form" accept-charset="UTF-8" class="foot-news-form js-email" novalidate>
              <input type="hidden" name="form_type" value="customer" />
              <input type="hidden" name="utf8" value="✓" />
              <input type="hidden" name="contact[tags]" value="newsletter">
              <input type="email" name="contact[email]" placeholder="Enter your email" aria-label="Email" required>
              <button class="btn btn-primary btn-sm" type="submit">Join</button>
            </form>
          </div>
        </div>
        ${cols}
        <div class="foot-col">
          <h4>Social</h4>
          <div class="foot-social">
            <a href="#" aria-label="Instagram">${svg('ig','',24)}</a>
            <a href="#" aria-label="Facebook">${svg('fb','',24)}</a>
            <a href="#" aria-label="TikTok">${svg('tiktok','',24)}</a>
          </div>
        </div>
      </div>
      <div class="foot-watermark" aria-hidden="true"><span class="fw-word">OSZEA</span></div>
      <div class="foot-bottom">
        <div class="fb-left">
          <span>© 2026 OSZEA Footwear. All rights reserved.</span>
          <a href="#">Privacy Policy</a><a href="#">Terms &amp; Conditions</a>
        </div>
        <div style="display:flex;align-items:center;gap:14px;flex-wrap:wrap">
          <div class="foot-pay"><span class="pay">VISA</span><span class="pay">MC</span><span class="pay">AMEX</span><span class="pay">PAY</span><span class="pay">GPAY</span></div>
          <span class="foot-cur">🇳🇿 NZD / AUD ▾</span>
        </div>
      </div>
    </div>
  </footer>`;
}

/* OVERLAYS */
function renderOverlays(){
  return `
  <div class="mmenu" id="mmenu">
    <div class="scrim" data-close-menu></div>
    <div class="panel">
      <div class="m-top"><img src="assets/oszea-logo.png" alt="OSZEA"><button class="icon-btn" data-close-menu aria-label="Close">${svg('close','',24)}</button></div>
      <a class="m-link" href="#featured" data-close-menu>Men <span class="arw">→</span></a>
      <a class="m-link" href="#featured" data-close-menu>Women <span class="arw">→</span></a>
      <a class="m-link" href="#featured" data-close-menu>Kids <span class="arw">→</span></a>
      <a class="m-link" href="#elements" data-close-menu>Elements <span class="arw">→</span></a>
      <a class="m-link" href="#socks" data-close-menu>Add Ons <span class="arw">→</span></a>
      <div class="m-foot">
        <a href="#featured" class="btn btn-primary btn-block" data-close-menu>Shop Waterproof Shoes <span class="arw">→</span></a>
        <a href="#forecast" class="btn btn-light btn-block" data-close-menu>Check the Weather</a>
      </div>
    </div>
  </div>

  <div class="cart" id="cart">
    <div class="scrim" data-close-cart></div>
    <div class="drawer">
      <div class="cart-head"><h3>Your Cart <span class="cnt" id="cartHeadCnt">(0)</span></h3><button class="icon-btn" data-close-cart aria-label="Close">${svg('close','',24)}</button></div>
      <div class="cart-ship" id="cartShip"><span id="cartShipTxt">Add $100 for free shipping</span><span class="bar"><i id="cartShipBar" style="width:0%"></i></span></div>
      <div class="cart-items" id="cartItems"></div>
      <div class="cart-foot">
        <div class="ct-row"><span class="muted">Subtotal</span><span class="ct-sub" id="cartSub">$0</span></div>
        <div class="ct-row"><span class="muted">Shipping</span><span class="ct-sub" id="cartShipFee">—</span></div>
        <div class="ct-row total"><span>Total</span><span class="ct-sub" id="cartTotal">$0</span></div>
        <button class="btn btn-primary btn-block" style="padding:16px">Secure Checkout <span class="arw">→</span></button>
        <p style="text-align:center;font-family:var(--font-mono);font-size:11px;color:var(--grey-400);margin-top:12px">30-day returns · Free shipping over $100</p>
      </div>
    </div>
  </div>

  <div class="verify" id="verify" aria-hidden="true">
    <div class="scrim" data-close-verify></div>
    <div class="verify-card" role="dialog" aria-label="Healthcare worker verification">
      <button class="verify-x" data-close-verify aria-label="Close">${svg('close','',24)}</button>
      <div class="verify-head">
        <span class="verify-badge">${svg('shield','',24)}</span>
        <div>
          <div class="verify-kicker">Healthcare Worker Offer · NZ &amp; AU</div>
          <h3>Verify for 20% off, every order</h3>
          <p>For nurses, doctors, paramedics, midwives &amp; support staff across New Zealand and Australia.</p>
        </div>
      </div>
      <form class="verify-form" id="verifyForm" novalidate>
        <div class="vf-row">
          <label class="vf-label">Country</label>
          <div class="vf-seg" id="vfCountry">
            <button type="button" data-c="NZ" class="active">New Zealand</button>
            <button type="button" data-c="AU">Australia</button>
          </div>
        </div>
        <div class="vf-row">
          <label class="vf-label" for="vfRole">Profession</label>
          <select class="vf-input" id="vfRole">
            <option>Registered Nurse</option>
            <option>Enrolled Nurse</option>
            <option>Nurse Practitioner</option>
            <option>Midwife</option>
            <option>Doctor / GP</option>
            <option>Paramedic</option>
            <option>Healthcare Assistant / Support</option>
            <option>Aged &amp; Disability Care</option>
          </select>
        </div>
        <div class="vf-row">
          <label class="vf-label" for="vfOrg">Employer / organisation</label>
          <input class="vf-input" id="vfOrg" placeholder="e.g. Auckland City Hospital" autocomplete="organization">
        </div>
        <div class="vf-row">
          <label class="vf-label" for="vfEmail">Work or personal email</label>
          <input class="vf-input" id="vfEmail" type="email" placeholder="you@health.govt.nz" autocomplete="email">
        </div>
        <button class="btn btn-primary btn-block vf-submit" type="submit">Verify Eligibility <span class="arw">→</span></button>
        <p class="vf-fine">${svg('lock','',24)} Checked instantly against healthcare credentials. We never store your documents. One-time code · single use · not combinable with other offers.</p>
      </form>
      <div class="verify-success" id="verifySuccess" aria-hidden="true">
        <span class="vs-check">${svg('check','',24)}</span>
        <div class="vs-title">You're verified ✦</div>
        <p class="vs-sub" id="vsSub">Welcome aboard. Here's your single-use code for <b>20% off</b>.</p>
        <button class="vs-code" id="vsCode" type="button"><span id="vsCodeVal">OSZEA-CARE-0000</span><span class="vs-copy">Copy</span></button>
        <p class="vs-apply">Auto-applies at checkout · valid for 12 months</p>
        <button class="btn btn-dark btn-block" data-close-verify type="button">Start Shopping 20% Off <span class="arw">→</span></button>
      </div>
    </div>
  </div>

  <div class="tweaks" id="tweaks">
    <div class="tweaks-head"><span class="tw-title"><span class="d"></span>Tweaks</span><button class="tweaks-close" id="tweaksClose">${svg('close','',24)}</button></div>
    <div class="tweaks-body">
      <div class="tw-group"><span class="tw-label">Hero alignment</span>
        <div class="tw-seg" id="twHero">
          <button data-hero="left" class="active">Left</button>
          <button data-hero="center">Centre</button>
        </div>
      </div>
      <div class="tw-group">
        <div class="tw-row"><span class="tw-label" style="margin:0">Hero overlay</span><span class="tw-val" id="twScrimVal">100%</span></div>
        <input type="range" class="tw-range" id="twScrim" min="40" max="130" step="10" value="100" style="margin-top:8px">
      </div>
      <div class="tw-group"><span class="tw-label">Accent colour</span>
        <div class="tw-swatches" id="twAccent">
          <span class="tw-sw active" data-accent="#3BB0AA" data-strong="#2f9e98" style="background:#3BB0AA"></span>
          <span class="tw-sw" data-accent="#5FC8C2" data-strong="#3BB0AA" style="background:#5FC8C2"></span>
          <span class="tw-sw" data-accent="#E8632A" data-strong="#cf5320" style="background:#E8632A"></span>
          <span class="tw-sw" data-accent="#4a6480" data-strong="#34495E" style="background:#4a6480"></span>
        </div>
      </div>
      <div class="tw-group">
        <div class="tw-row"><span class="tw-label" style="margin:0">Weather motion</span><span class="tw-val" id="twRainVal">30%</span></div>
        <input type="range" class="tw-range" id="twRain" min="0" max="100" step="10" value="30" style="margin-top:8px">
      </div>
    </div>
  </div>`;
}

function buildPage(){
  const shell = document.createElement('div');
  shell.innerHTML = renderOverlays();
  shell.querySelector('#mmenu')?.remove();
  shell.querySelector('#cart')?.remove();
  document.body.append(...shell.childNodes);
}
